// src/components/Button.js - shadcn style
import React from 'react';

const Button = ({ children, onClick, variant = 'default', size = 'md', title, className = '', ...props }) => {
  const baseStyles = `
    inline-flex items-center justify-center gap-2
    font-medium rounded-md
    transition-colors duration-150
    focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2
    disabled:opacity-50 disabled:cursor-not-allowed
  `;

  const variantStyles = {
    default: `
      bg-[hsl(240,5.9%,10%)] text-[hsl(0,0%,98%)]
      hover:bg-[hsl(240,5.9%,20%)]
      focus-visible:ring-[hsl(240,5.9%,10%)]
    `,
    secondary: `
      bg-[hsl(240,4.8%,95.9%)] text-[hsl(240,5.9%,10%)]
      border border-[hsl(240,5.9%,90%)]
      hover:bg-[hsl(240,4.8%,90%)]
      focus-visible:ring-[hsl(240,5.9%,10%)]
    `,
    danger: `
      bg-[hsl(0,84.2%,60.2%)] text-[hsl(0,0%,98%)]
      hover:bg-[hsl(0,84.2%,55%)]
      focus-visible:ring-[hsl(0,84.2%,60.2%)]
    `,
    ghost: `
      bg-transparent text-[hsl(240,5.9%,10%)]
      hover:bg-[hsl(240,4.8%,95.9%)]
      focus-visible:ring-[hsl(240,5.9%,10%)]
    `,
    outline: `
      bg-transparent text-[hsl(240,5.9%,10%)]
      border border-[hsl(240,5.9%,90%)]
      hover:bg-[hsl(240,4.8%,95.9%)]
      focus-visible:ring-[hsl(240,5.9%,10%)]
    `,
    // Legacy variants for backwards compatibility
    blue: `
      bg-[hsl(240,5.9%,10%)] text-[hsl(0,0%,98%)]
      hover:bg-[hsl(240,5.9%,20%)]
      focus-visible:ring-[hsl(240,5.9%,10%)]
    `,
    green: `
      bg-[hsl(142.1,76.2%,36.3%)] text-[hsl(0,0%,98%)]
      hover:bg-[hsl(142.1,76.2%,30%)]
      focus-visible:ring-[hsl(142.1,76.2%,36.3%)]
    `,
    gray: `
      bg-[hsl(240,4.8%,95.9%)] text-[hsl(240,5.9%,10%)]
      border border-[hsl(240,5.9%,90%)]
      hover:bg-[hsl(240,4.8%,90%)]
      focus-visible:ring-[hsl(240,5.9%,10%)]
    `,
    red: `
      bg-[hsl(0,84.2%,60.2%)] text-[hsl(0,0%,98%)]
      hover:bg-[hsl(0,84.2%,55%)]
      focus-visible:ring-[hsl(0,84.2%,60.2%)]
    `,
    black: `
      bg-[hsl(240,5.9%,10%)] text-[hsl(0,0%,98%)]
      hover:bg-[hsl(240,5.9%,20%)]
      focus-visible:ring-[hsl(240,5.9%,10%)]
    `,
  };

  const sizeStyles = {
    sm: 'px-3 py-1.5 text-xs',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-2.5 text-base',
    icon: 'p-2',
  };

  const classes = `${baseStyles} ${variantStyles[variant] || variantStyles.default} ${sizeStyles[size]} ${className}`.replace(/\s+/g, ' ').trim();

  return (
    <button
      onClick={onClick}
      className={classes}
      title={title}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
